"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-five/sections/sliderSection.tsx */

import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type SliderSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Certified Medical Professionals" | "Advanced Diagnostic Tools" | "Online Appointment Booking" | "Electronic Health Records" */
    h30Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
};
export type HomeFiveSliderSectionGeneratedProps = {
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: SliderSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    /** Default: "left" */
    sectionDiv0DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv0DivDataSpeed?: string;
    sliderSectionServicesSlides: SliderSectionServicesSlidesItem[];
    sliderSectionServicesSlidesItemWrapper?: (item: SliderSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    sliderSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    sliderSectionServicesSlidesH3Visible?: boolean;
    sliderSectionServicesSlidesH3Renderer?: (item: SliderSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    sliderSectionServicesSlidesH3Props?: Partial<ComponentProps<"h3">> | ((item: SliderSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
};

const HomeFiveSliderSectionGenerated: FC<HomeFiveSliderSectionGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    sectionDiv0DivDataDirection = "left",
    sectionDiv0DivDataSpeed = "slow",
    divH30H3Props,
    sliderSectionServicesSlides,
    sliderSectionServicesSlidesItemWrapper,
    sliderSectionServicesSlidesRenderer,
    sliderSectionServicesSlidesH3Visible,
    sliderSectionServicesSlidesH3Renderer,
    sliderSectionServicesSlidesH3Props,
}) => {
    return (
        <section className="slider-section slider-section-five wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="horizontal-slide slide-one d-flex" data-direction={sectionDiv0DivDataDirection} data-speed={sectionDiv0DivDataSpeed}>
                <div className="slide-list d-flex gap-4">
                    {renderCollectionNode(
                        sliderSectionServicesSlides,
                        (item: SliderSectionServicesSlidesItem) => (
                            <div className={item.className ?? "services-slide"} key={item.key}>
                                {renderItemNode(sliderSectionServicesSlidesH3Visible, sliderSectionServicesSlidesH3Renderer, item, (
                                    <h3 {...(typeof sliderSectionServicesSlidesH3Props === "function" ? sliderSectionServicesSlidesH3Props(item) : (sliderSectionServicesSlidesH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>{item.h30Text}</h3>
                                ))}
                            </div>
                        ),
                        sliderSectionServicesSlidesItemWrapper,
                        sliderSectionServicesSlidesRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeFiveSliderSectionGenerated;
